export enum PageType {
    Selector = "Product Selector",
    Detail = "Product Selector Product Detail"
}